import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import {ConnectionNextSteps} from '../../../setup/connection-next-steps/connection-next-steps';

type Props = {
    onClose: () => void;
};

export function ConnectionNextStepsCta(props: Props) {
    return (
        <OnboardingBody title=''>
            <ConnectionNextSteps onClose={props.onClose} />
        </OnboardingBody>
    );
}
